//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import React from 'react';

import { AssignmentDateTabContainer } from '../__date-tab/assignment__date-tab.container';

interface Props {
    activeSubscriptionSlug: string | null;
    lessonMode: CLESSON_MODES;
    canChangeAssignmentDates: boolean;
}

export const AssignmentDateMode = React.memo((props: Props) => {
    const { activeSubscriptionSlug, canChangeAssignmentDates, lessonMode } = props;

    return (
        <AssignmentDateTabContainer
            activeSubscriptionSlug={activeSubscriptionSlug}
            disabled={!canChangeAssignmentDates}
            lessonMode={lessonMode}
        />
    );
});
